import { writable, get } from 'svelte/store';
import { getCart } from './requests.js';

const fetchedCart = JSON.parse(localStorage.getItem('cart')) || null;

export const cart = writable(fetchedCart);
export const formdata = writable();
export const user = writable();

cart.subscribe(value => {
  localStorage.setItem("cart", JSON.stringify(value));
});

export const loadCart = async () => {
  const response = await getCart(get(cart));
  cart.set(response.data);
  
  if (window.hasOwnProperty('hydrant')) window.hydrant.cart();
}

export const deliveryMethods = writable();
export const paymentServices = writable();

export const Stages = Object.freeze({
  CART:         
    {name: 'Koszyk'},
  FORM:         
    {name: 'Informacje'},
  SUMMARY:      
    {name: 'Podsumowanie'},
  PLACED:      
    {name: 'Potwierdzenie zamówienia'}
});

const fetchedStage = JSON.parse(localStorage.getItem('stage')) || Stages.CART;
export const stage = writable(fetchedStage);
